// extracted by mini-css-extract-plugin
export default {"navLogo":"_3sUJk","navLogoIcon":"A3Ui9"};